import React, { useEffect, useState } from "react";
import { Download, Loader2 } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const tok = () => "Bearer " + (localStorage.getItem("go_oil_token") || "");

async function downloadZip(url, fname) {
  const r = await fetch(`${BASE}${url}`, { headers: { Authorization: tok() } });
  if (!r.ok) {
    let msg = "Backup failed";
    try { const j = await r.json(); if (j && typeof j.detail === "string") msg = j.detail; } catch (e) { /* ignore */ }
    throw new Error(msg);
  }
  const blob = await r.blob();
  const a = document.createElement("a");
  const u = URL.createObjectURL(blob);
  a.href = u; a.download = fname;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(u);
}

export function BackupPage() {
  const [logins, setLogins] = useState([]);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    fetch(`${BASE}/api/dms/backup/logins`, { headers: { Authorization: tok() } })
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setLogins(Array.isArray(d) ? d : []))
      .catch(() => setLogins([]));
  }, []);

  const run = async (key, url, name) => {
    setBusy(key); setErr("");
    try { await downloadZip(url, name); } catch (e) { setErr(e.message || "Backup failed"); } finally { setBusy(""); }
  };
  const today = new Date().toISOString().slice(0, 10);
  const btn = "inline-flex items-center gap-2 rounded-md border border-[#c9a227] bg-white px-4 py-2 text-sm font-medium text-[#8a6600] hover:bg-amber-50 disabled:opacity-60";

  return (
    <div className="space-y-6" data-testid="backup-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Backup</h1>
        <p className="text-sm text-slate-500">Download a copy of your data. Keep it safe outside the server.</p>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-5">
        <div className="font-semibold">All Backup</div>
        <p className="mb-3 text-sm text-slate-500">Whole database (every collection) in one zip. Use this to restore everything on a new server.</p>
        <button type="button" className={btn} disabled={!!busy} data-testid="backup-all-btn"
          onClick={() => run("all", "/api/dms/backup/full", `full_backup_${today}.zip`)}>
          {busy === "all" ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
          {busy === "all" ? "Preparing..." : "Download All Backup"}
        </button>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white p-5">
        <div className="font-semibold">Login-wise Backup</div>
        <p className="mb-3 text-sm text-slate-500">Select a distributor login and download only its data.</p>
        <div className="flex flex-wrap items-center gap-3">
          <select value={sel} onChange={(e) => setSel(e.target.value)}
            className="min-w-[240px] rounded-md border border-slate-300 bg-white px-3 py-2 text-sm" data-testid="backup-login-select">
            <option value="">Select login...</option>
            {logins.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
          <button type="button" className={btn} disabled={!sel || !!busy} data-testid="backup-login-btn"
            onClick={() => run("login", `/api/dms/backup/login/${sel}`, `login_backup_${today}.zip`)}>
            {busy === "login" ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
            {busy === "login" ? "Preparing..." : "Download This Login's Backup"}
          </button>
        </div>
      </div>
      {err && <div className="text-sm text-red-600">{err}</div>}
    </div>
  );
}
